import {
    BrowserRouter as Router,
    Routes,
    Route
} from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import Job from '../pages/Job/Job';
import Jobs from '../pages/Jobs/Jobs';
import Chat from '../pages/Chat/Chat';
import Login from '../pages/Login/Login';
import MyJobs from '../pages/MyJobs/MyJobs';
import Welcome from '../pages/Welcome/Welcome';
import ManageJob from '../pages/ManageJob/ManageJob';
import Jobseekers from '../pages/Jobseekers/Jobseekers';
import SignupLayout from '../components/Layouts/signupLayout';
import DefaultLayout from '../components/Layouts/defaultLayout';
import TrackUserVisit from '../components/Other/TrackUserVisit';
import ResetPassword from '../pages/ResetPassword/ResetPassword';
import CreateAccount from '../pages/CreateAccount/CreateAccount';
import DiscountOffer from '../pages/DiscountOffer';
import SavedJobseekers from '../pages/SavedJobseekers/SavedJobseekers';
import SubscriptionDowngrade from '../pages/SubscriptionDowngrade/SubscriptionDowngrade';
import EmployerProfile from '../pages/Employer/Profile/EmployerProfile';
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute';
import JobseekerProfile from '../pages/Jobseeker/Profile/JobseekerProfile';
import ProfileSettings from '../pages/Profile/ProfileSettings/ProfileSettings';
import ProfileInsights from '../pages/Profile/ProfileInsights/ProfileInsights';
import ProfileVerification from '../pages/Profile/ProfileVerification/ProfileVerification';
import ProfileEmployerSubscription from '../pages/Profile/ProfileEmployerSubscription/ProfileEmployerSubscription';
import Questionnaire from '../pages/Questionnaire/Questionnaire';
import SubscriptionPause from '../pages/SubscriptionPause/SubscriptionPause';
import PaymentConfirmation from '../pages/Profile/Billing/PaymentConfirmation';

function RoutesSetup() {
    return (
        <Router>
            <TrackUserVisit />
            <Toaster position="bottom-right" reverseOrder={false} />
            <Routes>
                <Route path="/" element={<SignupLayout />}>
                      </Route>

                <Route path="/" element={<DefaultLayout />}>
                    <Route path="login" element={
                        <ProtectedRoute userStatus="notLoggedIn">
                            <Login />
                        </ProtectedRoute>
                    } />
                    <Route path="welcome" element={
                        <ProtectedRoute userStatus="loggedIn">
                            <Welcome />
                        </ProtectedRoute>
                    } />
                    <Route path="reset-password" element={
                        <ProtectedRoute userStatus="notLoggedIn">
                            <ResetPassword />
                        </ProtectedRoute>
                    } />
                    <Route path="create-account" element={
                        <ProtectedRoute userStatus="notLoggedIn">
                            <CreateAccount />
                        </ProtectedRoute>
                    } />

                    <Route path="employers/:slug" element={<EmployerProfile />} />
                    <Route path="jobseekers/:slug" element={<JobseekerProfile />} />
                    <Route
                        path="profile"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="profile/personal-information"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="profile/account"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="profile/contact-information"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="profile/company-information"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="profile/work-experience"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="profile/education"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="profile/skills"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="profile/occupation"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="profile/job-preferences"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="profile/resume"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="profile/certification"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="profile/portfolio"
                        element={
                            <ProtectedRoute>
                                {({ user }) =>
                                    user?.account_type === "jobseeker" ? (
                                        <JobseekerProfile />
                                    ) : (
                                        <EmployerProfile />
                                    )
                                }
                            </ProtectedRoute>
                        }
                    />
                    <Route path="profile/settings" element={
                        <ProtectedRoute userStatus="loggedIn">
                            <ProfileSettings />
                        </ProtectedRoute>
                    } />

                    <Route path="profile/billing" element={
                        <ProtectedRoute userStatus="loggedIn">
                            <ProfileEmployerSubscription />
                        </ProtectedRoute>
                    } />
                    <Route path="profile/billing/payment-confirmation" element={
                        <ProtectedRoute userStatus="loggedIn">
                            <PaymentConfirmation />
                        </ProtectedRoute>
                    } />
                    <Route path="profile/billing-history" element={
                        <ProtectedRoute userStatus="loggedIn">
                            <ProfileEmployerSubscription />
                        </ProtectedRoute>
                    } />
                    <Route path="profile/plan-usage" element={
                        <ProtectedRoute userStatus="loggedIn">
                            <ProfileEmployerSubscription />
                        </ProtectedRoute>
                    } />
                    <Route path="profile/features" element={
                        <ProtectedRoute userStatus="loggedIn">
                            <ProfileEmployerSubscription />
                        </ProtectedRoute>
                    } />
                    <Route path="invoice/:id" element={
                        <ProtectedRoute userStatus="loggedIn"  >
                            <ProfileEmployerSubscription />
                        </ProtectedRoute>
                    } />
                    <Route path="profile/verification" element={
                        <ProtectedRoute userStatus="loggedIn">
                            <ProfileVerification />
                        </ProtectedRoute>
                    } />
                    <Route path="profile/insights" element={
                        <ProtectedRoute userStatus="loggedIn">
                            <ProfileInsights />
                        </ProtectedRoute>
                    } />
                    <Route path="subscription-downgrade" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="employer">
                            <SubscriptionDowngrade />
                        </ProtectedRoute>
                    } />
                    <Route path="subscriptions" element={
                        <ProtectedRoute userStatus="loggedIn">
                            {({ user }) =>
                                user?.account_type === "jobseeker" ? (
                                    <ProfileVerification />
                                ) : (
                                    <ProfileEmployerSubscription />
                                )
                            }
                        </ProtectedRoute>
                    } />
                    <Route path="profile/verify" element={
                        <ProtectedRoute userStatus="loggedIn" userRole='jobseeker'>
                            <ProfileVerification />
                        </ProtectedRoute>
                    } />
                    <Route path="profile/my-jobs" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="employer">
                            <MyJobs />
                        </ProtectedRoute>
                    } />

                    <Route path="employer-portal" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="employer">
                            <ManageJob />
                        </ProtectedRoute>
                    } />
                    <Route path="employer-portal/jobs" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="employer">
                            <ManageJob />
                        </ProtectedRoute>
                    } />
                    <Route path="employer-portal/applicants" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="employer">
                            <ManageJob />
                        </ProtectedRoute>
                    } />
                    <Route path="employer-portal/create-job" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="employer">
                            <ManageJob />
                        </ProtectedRoute>
                    } />
                    <Route path="employer-portal/candidates" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="employer">
                            <ManageJob />
                        </ProtectedRoute>
                    } />
                    <Route path="employer-portal/:id/edit" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="employer">
                            <ManageJob />
                        </ProtectedRoute>
                    } />
                    <Route path="employer-portal/:id" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="employer">
                            <ManageJob />
                        </ProtectedRoute>
                    } />
                    <Route path="jobs/:id/edit" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="employer">
                            <ManageJob />
                        </ProtectedRoute>
                    } />

                    <Route path="jobs/saved" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="jobseeker">
                            <MyJobs />
                        </ProtectedRoute>
                    } />

                    <Route path="jobs" element={<Jobs />} />
                    <Route path="jobs/:slug" element={<Job />} />

                    <Route path="jobseekers" element={<Jobseekers />} />
                    <Route path="jobseekers/saved" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="employer">
                            <SavedJobseekers />
                        </ProtectedRoute>
                    } />
                    <Route path="chat" element={
                        <ProtectedRoute userStatus="loggedIn">
                            <Chat />
                        </ProtectedRoute>
                    } />

                    <Route path="discount-offer" element={
                        <ProtectedRoute userStatus="loggedIn">
                            <DiscountOffer />
                        </ProtectedRoute>
                    } />
                    
                    <Route path="questionnaire" element={
                        <ProtectedRoute userStatus="loggedIn">
                            <Questionnaire />
                        </ProtectedRoute>
                    } />

                    <Route path="subscription-pause" element={
                        <ProtectedRoute userStatus="loggedIn" userRole="employer">
                            <SubscriptionPause />
                        </ProtectedRoute>
                    } />
             
                </Route>
            </Routes>
        </Router>
    );
}

export default RoutesSetup;